import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import {
    SubscriptionPlanModelInterface,
    SubscriptionPlanModelResponse,
} from 'src/app/interface/subscription-plan-model.interface';
import {
    SubscriptionTierModelInterface,
    SubscriptionTierModelResponse,
} from 'src/app/interface/subscription-tier-model.interface';
import { OpenIdProfileBase } from 'src/app/mixin/presets';
import { OpenIdService } from 'src/app/service/open-id.service';
import { ConfirmComponent } from 'src/app/dialog/confirm/confirm.component';

@Component({
    selector: 'app-view-subscriptions-plans-tiers',
    templateUrl: './tiers.component.html',
    styleUrls: ['./tiers.component.css'],
})
export class TiersComponent extends OpenIdProfileBase implements OnInit {
    public planId: number = 0;
    public planModel?: SubscriptionPlanModelInterface;

    public tierModels: SubscriptionTierModelInterface[] = [];

    public columnHeadings: string[] = [
        'control',
        'id',
        'sequence_number',
        'label',
        'description',
        'amount',
        'period_unit',
        'period_count',
        'cycles',
    ];

    constructor(
        private dialog: MatDialog,
        private httpClient: HttpClient,
        openIdService: OpenIdService,
        private route: ActivatedRoute
    ) {
        super(openIdService);
    }

    ngOnInit(): void {
        // need plan and tiers
        this.$openIdReady.subscribe(() => {
            this.route.params.subscribe((params) => {
                this.planId = Number(params['id']);
                this.getPlan();
                this.getTiers();
            });
        });
    }

    public confirmDelete(tierModel: SubscriptionTierModelInterface) {
        let dialog = this.dialog.open(ConfirmComponent, {
            data: {
                label: 'Tier Delete Request',
                message: `Delete tier ${tierModel.label}?`,
            },
        });

        dialog.afterClosed().subscribe((data) => {
            if (!data.data) return;
            this.httpClient
                .delete(`subscription_tiers/${tierModel.id}/`)
                .subscribe(() => {
                    this.getTiers();
                });
        });
    }

    private getPlan() {
        let options = {
            params: new HttpParams().set('id', this.planId),
        };
        this.httpClient
            .get<SubscriptionPlanModelResponse>('subscription_plans', options)
            .subscribe((response: SubscriptionPlanModelResponse) => {
                if (response.count != 1) {
                    console.log('Plan not found.');
                    return;
                }
                this.planModel = response.results[0];
            });
    }

    private getTiers() {
        let options = {
            params: new HttpParams()
                .set('subscription_plan', this.planId)
                .set('ordering', 'sequence_number'),
        };
        this.httpClient
            .get<SubscriptionTierModelResponse>('subscription_tiers', options)
            .subscribe((response: SubscriptionTierModelResponse) => {
                this.tierModels = response.results;
            });
    }

    private getRecords() {
        let options = {
            params: new HttpParams().set('subscription_plan', this.planId),
        };
        this.httpClient.get('subscription_tiers', options).subscribe((resp) => {
            console.log(resp);
        });
    }
}
